import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { useState } from 'react';
import { customerOrderApi } from '../api';
import { ORDER_STATUS_QUERY_CONFIG, ORDER_STATUS_QUERY_KEY } from './config';
import type { OrderStatusResponse } from '../api/order/model';

export const useOrderStatus = (
  accountId: number | undefined,
  statusPollingInterval?: number,
): UseQueryResult<OrderStatusResponse> => {
  const [refetchInterval, setRefetchInterval] = useState<number | false>(
    statusPollingInterval ?? false,
  );

  return useQuery(
    ORDER_STATUS_QUERY_KEY,
    () => customerOrderApi.getOrderStatus(accountId as number),
    {
      ...ORDER_STATUS_QUERY_CONFIG,
      enabled: accountId !== undefined,
      refetchInterval,
      onSettled: (data) => {
        if (data?.status !== 'PROCESSING') {
          setRefetchInterval(false);
        }
      },
    },
  );
};
